import { NumberUtils } from "neo-common";
import { BetManager } from "../Managers/BetManager";

export class Bet {
    public type: string;
    public selection: number;
    public value: number;

    private _betHistory: Array<number>;

    constructor(type: string, selection: number, value: number) {
        this.type = type;
        this.selection = selection;
        this.value = value;
        this._betHistory = [value];
    }

    public addValue(value: number): void {
        this._betHistory.push(value);
        this.value = parseFloat(NumberUtils.add(this.value, value));
    }

    public revertLastValue(): void {
        let value = this._betHistory.pop();

        if (value) {
            this.value = parseFloat(NumberUtils.subtract(this.value, value));
        }
    }

    public resetValue(): void {
        this.value = 0;
        this._betHistory = [];
    }

    public getChips(): { [betIndex: number]: number } {
        let chips = {};
        let curentValue = this.value;

        for (let i = BetManager.Chips.length - 1; i >= 0; i--) {
            if (curentValue > 0) {
                let mod = Math.floor(curentValue / BetManager.Chips[i]);

                if (mod > 0) {
                    curentValue = parseFloat(
                        NumberUtils.subtract(curentValue, NumberUtils.multiply(mod, BetManager.Chips[i])),
                    );
                    chips[i] = mod;
                }
            }
        }

        return chips;
    }

    public getBetPlaceId(): string {
        return this.type + "_" + this.selection;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Bet.ts
 **/